"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const elLocaleData = require("i18next-icu/locale-data/el");
exports.default = elLocaleData;
//# sourceMappingURL=el.js.map